module.exports = __webpack_public_path__ + "img/1440.212847d7.jpg";